/* eslint-disable linebreak-style */
import { inject, Injectable, OnDestroy } from '@angular/core';
import { initialize, Event } from '@harnessio/ff-javascript-client-sdk';
import { environment } from 'src/environments/environment';
import { FeatureFlagService } from '../feature-flag-service/feature-flag-service';
import { Router } from '@angular/router';
import { ComponentRoutesEnum } from '@shared/utils/component-routes';

@Injectable({
	providedIn: 'root'
})
export class HarnessService implements OnDestroy {
	private harness: any;
	private router = inject(Router);
	private harnessApiCount = 2;

	private featureFlagService = inject(FeatureFlagService);

	private routeErrorPage(): void {
		this.router.navigate([ComponentRoutesEnum.HAND_BREAK]);
	}

	public loadConfig(): void {
		this.harness = initialize(environment.harnessApiKey, {
			identifier: 'WEB'
		});

		this.harness.on(Event.ERROR, () => {
			if (this.harnessApiCount) {
				this.harnessApiCount = this.harnessApiCount - 1;
				this.loadConfig();
			} else {
				this.routeErrorPage();
			}
		});
		this.harness.on(Event.CHANGED, this.handleChange);
	}
	
	// Tech Debt: Need to update error handling with proper logs
	public initialize(): Promise<void> {
		return new Promise((resolve, reject) => {
			try {
				this.loadConfig();
				this.harness.on(Event.READY, (flags: any) => {
					this.featureFlagService.setFlags(flags);
					if (!environment.production) {
						console.log('Feature Flags initialized:', flags);
					}
					return resolve();
				});
				this.harness.on(Event.ERROR, () => reject('Harness initialization failed.'));
			} catch (error) {
				return reject(error);
			}
		}); 
	}

	private handleReady = (flags: any): void => {
		this.log('Flags from harness ready', flags);
		this.featureFlagService.setFlags(flags);
	};

	private handleChange = (flagInfo: any): void => {
		this.log('flaginfo', flagInfo);

		if (flagInfo.deleted) {
			this.log(`Flag ${flagInfo.flag} has been deleted`);
		} else {
			this.log(`Flag ${flagInfo.flag} changed to ${flagInfo.value}`);
			this.featureFlagService.setFlags({ [flagInfo.flag]: flagInfo.value });
		}
	};

	private log(message: string, data?: any): void {
		if (!environment.production) {
			console.log(message, data);
		}
	}

	ngOnDestroy(): void {
		this.harness.off(Event.READY, this.handleReady);
		this.harness.off(Event.CHANGED, this.handleChange);
	}
}
